export default "__VITE_ASSET__679aabe5__"